import React, { useMemo, useState } from 'react';
import { Form, Input, Select, Radio } from 'tea-component';

import {
  PAGE_TYPE_DATALAB,
  PAGE_TYPE_PATH, PAGE_TYPE_PRESET,
  PAGE_TYPE_URL,
  PAGE_TYPE_WORKBOOK,
  PAGE_TYPE_PDF,
  PAGE_TYPE_DASHBOARD_CUSTOM,
  PAGE_TYPE_DASHAPP,
  PAGE_TYPE_PUBLIC_URL,
  PAGE_TYPE_COS_URL,
  PAGE_TYPE_LOOKER,
  PAGE_TYPE_OUT_URL,
  PAGE_TYPE_AUTH_PATH,
  PAGE_TYPE_OUT_PATH
} from '@/pages/dashboard/_config/constant';
import { useDashboardPath } from '@/pages/dashboard/_config/databoardPath';

import PdfUploader from '@/pages/dashboard/components/LeftMenu/components/PdfUploader';

export default (props: any) => {
  const {
    selectedPath,
    setSelectedPath,
    setNamePathENErr,
    pathInfo,
    setPathStateInfo,
    pathInfoErr,
    setPathInfoErr,
    checkPathType,
    tableauList,
    isCustomEdit,
    formatMessage,
    presetExtInfo,
    setPresetExtStateInfo,
    pdfFile,
    setPdfFile,
    pdfFileUploadStatus,
    setPdfFileUploadStatus,
    presetExtInfoErr,
    lookerExtInfoErr,
    lookerExtInfo,
    setLookerExtStateInfo,
    checkLookerExtInfo,
    type,
  } = props;
  const pathList = useDashboardPath();
  const selectOptions = useMemo(() => {
    return tableauList?.map((item: { contentUrl: any; }) => {
      return {
        value: item?.contentUrl,
        text: item?.contentUrl,
      };
    });
  }, [tableauList]);


  const handleFileUploaded = () => {
    setPathInfoErr("");
  };

  const handleUploadSuccess = (path: string) => {
    setPathStateInfo({ pdf: path });
  };

  const handleUploadError = (error: Error) => {
    setPathInfoErr(formatMessage({ id: error.message.toString() }));
  };

  const handleDeleteFile = () => {
    setPdfFile(null);
    setPathStateInfo({ pdf: '' });
  };

  const [showNoMatchTip, setShowNoMatchTip] = useState(false);
  const onSearch = (value) => {
    // 将输入转为小写
    const lowerCaseValue = value.toLowerCase();
    // 判断pathList中是否存在大小写不敏感的匹配项
    const match = pathList.find(item => item.value.toLowerCase().includes(lowerCaseValue));
    if (!match) {
      setShowNoMatchTip(true); // 如果不存在，显示提示
    } else {
      setShowNoMatchTip(false);  // 如果存在，不显示提示
    }
  };

  return (
    <>
      <Form.Item
        showStatusIcon={false}
        label={formatMessage({ id: 'menu_link' })}
        required={true}
      >
        <Radio.Group value={selectedPath} onChange={setSelectedPath}>
          {type !== 'add' && ( <Radio disabled={isCustomEdit} name={PAGE_TYPE_WORKBOOK}>{formatMessage({ id: 'menu_path_type_webhook_url' })}</Radio>)}
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_URL}>{formatMessage({ id: 'menu_path_type_url' })}</Radio>
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_PATH}>{formatMessage({ id: 'menu_path_type_Path' })}</Radio>
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_DATALAB}>{formatMessage({ id: 'menu_path_type_datalab' })}</Radio>
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_PRESET}>{formatMessage({ id: 'menu_path_type_preset' })}</Radio>
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_PDF}>{formatMessage({ id: 'menu_path_type_pdf' })}</Radio>
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_DASHAPP}>{formatMessage({ id: 'menu_path_type_dashApp' })}</Radio>
          <Radio disabled={!isCustomEdit} name={PAGE_TYPE_DASHBOARD_CUSTOM}>{formatMessage({ id: 'menu_path_type_custom' })}</Radio>
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_PUBLIC_URL}>{formatMessage({ id: 'menu_path_type_public_url' })}</Radio>
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_COS_URL}>{formatMessage({ id: 'menu_path_type_cos_url' })}</Radio>
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_LOOKER}>{formatMessage({ id: 'menu_path_type_looker' })}</Radio>
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_OUT_URL}>{formatMessage({ id: 'menu_path_type_out_url' })}</Radio>
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_OUT_PATH}>{formatMessage({ id: 'menu_path_type_out_path' })}</Radio>
          <Radio disabled={isCustomEdit} name={PAGE_TYPE_AUTH_PATH}>{formatMessage({ id: 'menu_path_type_auth_path' })}</Radio>
        </Radio.Group>
      </Form.Item>
      {selectedPath === PAGE_TYPE_WORKBOOK && <Form.Item
        showStatusIcon={false}
        status={pathInfoErr ? 'error' : undefined}
        message={pathInfoErr}>
        <Select
          size='full'
          matchButtonWidth={true}
          appearance="button"
          options={selectOptions}
          value={pathInfo.workbookUrl}
          onChange={val => { setPathStateInfo({ workbookUrl: val }) }}
          onBlur={checkPathType}
          searchable={true}
          onSearch={onSearch}
          placeholder={formatMessage({ id: 'menu_path_placeholder' })}
          tips={
            (showNoMatchTip || selectOptions.length === 0) ? formatMessage({ id: 'menu_select_no_data' }) : ''
          }
        />

      </Form.Item>}
      {selectedPath === PAGE_TYPE_PUBLIC_URL && <Form.Item
        showStatusIcon={false}
        status={pathInfoErr ? 'error' : undefined}
        message={pathInfoErr}>
        <Input style={{ width: '100%' }} value={pathInfo.publicUrl} onChange={(val) => { setPathStateInfo({ publicUrl: val }) }} onBlur={checkPathType} placeholder={formatMessage({ id: 'menu_path_public_url_placeholder' })} />
      </Form.Item>}
      {selectedPath === PAGE_TYPE_URL && <Form.Item
        showStatusIcon={false}
        status={pathInfoErr ? 'error' : undefined}
        message={pathInfoErr}>
        <Input style={{ width: '100%' }} value={pathInfo.url} onChange={(val) => { setPathStateInfo({ url: val }) }} onBlur={checkPathType} placeholder={formatMessage({ id: 'menu_path_tableau_placeholder' })} />
      </Form.Item>}
      {selectedPath === PAGE_TYPE_PATH && <Form.Item
        showStatusIcon={false}
        status={pathInfoErr ? 'error' : undefined}
        message={pathInfoErr}>
        <Select
          size='full'
          matchButtonWidth={true}
          appearance="button"
          options={pathList || []}
          value={pathInfo.path}
          onChange={val => { setPathStateInfo({ path: val });setNamePathENErr('') }}
          onBlur={checkPathType}
          searchable={true}
          onSearch={onSearch}
          placeholder={formatMessage({ id: 'menu_path_placeholder' })}
          tips={
            (showNoMatchTip || pathList?.length == 0) ? formatMessage({ id: 'menu_select_no_data' }) : ''
          }
          
        />
      </Form.Item>}
      {selectedPath === PAGE_TYPE_DATALAB && <Form.Item
        status={pathInfoErr ? 'error' : undefined}
        showStatusIcon={false}
        message={pathInfoErr}>
        <Input style={{ width: '100%' }} value={pathInfo.dashboardUUID} onChange={(val) => { setPathStateInfo({ dashboardUUID: val }) }} onBlur={checkPathType}
          placeholder={formatMessage({ id: 'menu_path_datalab_placeholder' })}
        />
      </Form.Item>}
      {selectedPath === PAGE_TYPE_PRESET && <>
        <Form.Item
          showStatusIcon={false}
          status={pathInfoErr ? 'error' : undefined}
          message={pathInfoErr}>
          <Input style={{ width: '100%' }} value={pathInfo.presetId} onChange={(val) => { setPathStateInfo({ presetId: val }) }} onBlur={checkPathType}
            placeholder={formatMessage({ id: 'menu_path_preset_placeholder' })}
          />
        </Form.Item>
        <Form.Item
          showStatusIcon={false}
          status={presetExtInfoErr.workspaceId ? 'error' : undefined}
          message={presetExtInfoErr.workspaceId}>
          <Input style={{ width: '100%' }} value={presetExtInfo.workspaceId} onChange={(val) => { setPresetExtStateInfo({ workspaceId: val }) }}
            placeholder={formatMessage({ id: 'preset_ext_info_workspace_id_placeholder' })}
          />
        </Form.Item>
        <Form.Item
          showStatusIcon={false}
          status={presetExtInfoErr.workspaceRegion ? 'error' : undefined}
          message={presetExtInfoErr.workspaceRegion}>
          <Input style={{ width: '100%' }} value={presetExtInfo.workspaceRegion} onChange={(val) => { setPresetExtStateInfo({ workspaceRegion: val }) }}
            placeholder={formatMessage({ id: 'preset_ext_info_workspace_region_placeholder' })}
          />
        </Form.Item>
        <Form.Item
          showStatusIcon={false}
          status={presetExtInfoErr.teamId ? 'error' : undefined}
          message={presetExtInfoErr.teamId}>
          <Input style={{ width: '100%' }} value={presetExtInfo.teamId} onChange={(val) => { setPresetExtStateInfo({ teamId: val }) }}
            placeholder={formatMessage({ id: 'preset_ext_info_team_id_placeholder' })}
          />
        </Form.Item>
        <Form.Item
          label={formatMessage({id: 'menu_extra_info'})}
          showStatusIcon={false}
          status={presetExtInfoErr.extraInfo ? 'error' : undefined}
          message={presetExtInfoErr.extraInfo}>
          <Input style={{ width: '100%' }} value={presetExtInfo.extraInfo} onChange={(val) => { setPresetExtStateInfo({ extraInfo: val }) }}
            placeholder={formatMessage({id: 'menu_extra_info_placeholder'})}
          />
        </Form.Item>
      </>}

      {selectedPath === PAGE_TYPE_PDF && <Form.Item
        status={pathInfoErr ? 'error' : undefined}
        showStatusIcon={false}
        message={pathInfoErr}>

        <PdfUploader
          onFileUploaded={handleFileUploaded}
          onSuccess={handleUploadSuccess}
          onDelete={handleDeleteFile}
          onError={handleUploadError}
          pdfFileUploadStatus={pdfFileUploadStatus}
          setPdfFileUploadStatus={setPdfFileUploadStatus}
          pdfFile={pdfFile}
          setPdfFile={setPdfFile}
          value={pathInfo.pdf}
          onChange={(val) => { setPathStateInfo({ pdf: val }) }}
          onBlur={checkPathType}

        />
      </Form.Item>}

      {selectedPath === PAGE_TYPE_DASHAPP && <Form.Item
        status={pathInfoErr ? 'error' : undefined}
        showStatusIcon={false}
        message={pathInfoErr}>
        <Input style={{ width: '100%' }} value={pathInfo.dashApp} onChange={(val) => { setPathStateInfo({ dashApp: val }) }} onBlur={checkPathType}
          placeholder={formatMessage({ id: 'menu_path_dashApp_placeholder' })}
        />
      </Form.Item>}

      {selectedPath === PAGE_TYPE_COS_URL && <Form.Item
        status={pathInfoErr ? 'error' : undefined}
        showStatusIcon={false}
        message={pathInfoErr}>
        <Input style={{ width: '100%' }} value={pathInfo.cosUrl} onChange={(val) => { setPathStateInfo({ cosUrl: val }) }} onBlur={checkPathType}
          placeholder={formatMessage({ id: 'menu_path_cos_url_placeholder' })}
        />
      </Form.Item>}

      {selectedPath === PAGE_TYPE_OUT_URL && <Form.Item
        status={pathInfoErr ? 'error' : undefined}
        showStatusIcon={false}
        message={pathInfoErr}>
        <Input style={{ width: '100%' }} value={pathInfo.outUrl} onChange={(val) => { setPathStateInfo({ outUrl: val }) }} onBlur={checkPathType}
          placeholder={formatMessage({ id: 'menu_path_out_url_placeholder' })}
        />
      </Form.Item>}

      {selectedPath === PAGE_TYPE_OUT_PATH && <Form.Item
        status={pathInfoErr ? 'error' : undefined}
        showStatusIcon={false}
        message={pathInfoErr}>
        <Input style={{ width: '100%' }} value={pathInfo.outPath} onChange={(val) => { setPathStateInfo({ outPath: val }) }} onBlur={checkPathType}
          placeholder={formatMessage({ id: 'menu_path_out_path_placeholder' })}
        />
      </Form.Item>}

      {selectedPath === PAGE_TYPE_AUTH_PATH && <Form.Item
        status={pathInfoErr ? 'error' : undefined}
        showStatusIcon={false}
        message={pathInfoErr}>
        <Input style={{ width: '100%' }} value={pathInfo.authPath} onChange={(val) => { setPathStateInfo({ authPath: val }) }} onBlur={checkPathType}
          placeholder={formatMessage({ id: 'menu_path_auth_path_placeholder' })}
        />
      </Form.Item>}

      {selectedPath === PAGE_TYPE_LOOKER && <>
        <Form.Item
          status={pathInfoErr ? 'error' : undefined}
          showStatusIcon={false}
          message={pathInfoErr}>
          <Input style={{ width: '100%' }} value={pathInfo.looker} onChange={(val) => { setPathStateInfo({ looker: val }) }} onBlur={checkPathType}
            placeholder={formatMessage({ id: 'menu_path_looker_placeholder' })}
          />
        </Form.Item>
        <Form.Item
          showStatusIcon={false}
          status={lookerExtInfoErr.lookerModels ? 'error' : undefined}
          message={lookerExtInfoErr.lookerModels}>
          <Input style={{ width: '100%' }} value={lookerExtInfo.lookerModels} onChange={(val) => { setLookerExtStateInfo({ lookerModels: val }) }}onBlur={checkLookerExtInfo}
            placeholder={formatMessage({ id: 'looker_ext_info_models_placeholder' })}
          />
        </Form.Item>
      </>}
    </>
  );
};
